/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const copy = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.454 6.115-.909-.979m.91.98v1.017m0-1.018v1.018M5.134 15h7.32a1 1 0 0 0 1-1V7.133M6.53 1H3c-.552 0-1 .445-1 .998v9.85c0 .552.448.998 1 .998h6.364a1 1 0 0 0 1-1V4.962M6.53 1h.573a1 1 0 0 1 .723.309l2.26 2.363a1 1 0 0 1 .278.69v.6M6.53 1v2.962a1 1 0 0 0 1 1h2.834m3.09 2.17h-.909"
    />
  </svg>
)
export default copy
